// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file admin/admin.proto (package lvdr.v2.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file admin/admin.proto.
 */
export const file_admin_admin: GenFile = /*@__PURE__*/
  fileDesc("ChFhZG1pbi9hZG1pbi5wcm90bxINbHZkci52Mi5hZG1pbiIWChRGZWF0dXJlc1VwZGF0ZWRFdmVudEImWiRnaXRodWIuY29tL2d2czQyL2x2ZHIvcHJvdG8vdjIvYWRtaW5iBnByb3RvMw");

/**
 * FeaturesUpdatedEvent signals that the catalog feature-flag state changed
 * (an admin flipped a flag, or a runtime override was reset to default).
 * The body is intentionally empty — the client refetches /api/v1/features
 * to pick up the new snapshot. Keeping catalog metadata out of the proto
 * avoids drift between the wire shape and the catalog source of truth in
 * internal/admin/feature_catalog.go.
 *
 * @generated from message lvdr.v2.admin.FeaturesUpdatedEvent
 */
export type FeaturesUpdatedEvent = Message<"lvdr.v2.admin.FeaturesUpdatedEvent"> & {
};

/**
 * Describes the message lvdr.v2.admin.FeaturesUpdatedEvent.
 * Use `create(FeaturesUpdatedEventSchema)` to create a new message.
 */
export const FeaturesUpdatedEventSchema: GenMessage<FeaturesUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_admin_admin, 0);

